<template>
  <div class="modal fade bulk-disclosure-overlay" id="bulk-disclosure-overlay" tabindex="-1" aria-labelledby="bulk-disclosure-overlay" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="bulk-disclosure-overlay-label">Universal TCPA Dislosure</h5>
        </div>
        <div class="modal-body">
          <div class="container-fluid">
            <div class="row pending-bulk-submit" v-for="pending in pendingBulkSubmits" :key="pending.offer.displayedOfferId">
              <div class="col-4">
                  <img class="school-logo" :src="pending.offer.logoURL" v-if="pending.offer.logoURL" />
              </div>
              <div class="col-6 school-title">
                {{pending.offer.name}}<br /><br />
                <div v-if="campusNameFound(pending) !== undefined">
                  Campus Preference: {{campusNameFound(pending)}}<br />
                </div>
                <div v-if="programNameFound(pending) !== undefined">
                  Program of Interest: {{programNameFound(pending)}}
                </div>
              </div>
              <div class="col-2"><button :disabled='disabledCancel' class="btn btn-danger cancel-offer" @click="cancelOffer(pending)">x</button></div>
              <div class="row">
                <hr />
              </div>
            </div>
            <div class="row">
              <div class="col-12 bulk-tcpa-required">Must Read:</div>
            </div>
            <div class="row">
              <div class="col-12 bulk-tcpa" v-html="mappedBulkTcpa"></div>
            </div>
          </div>
        </div>
        <div class="modal-footer">

          <PlayTCPAButton v-show="hasPlayTcpa" @submit="submitStep1" @disableCancel="disableCancel" websocket-name="lhcv" :opened="open" :has-play-tcpa="hasPlayTcpa" />

          <button class="btn btn-primary" @click="submitStep1" v-show="submitStep === 1 && !hasPlayTcpa">Submit!</button>
          <button class="btn btn-success" @click="submitOffers" v-show="submitStep === 2">
            <span class="fw-bold">></span> If TCPA is Confirmed,<br />
            <span class="fw-bold">CLICK HERE</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bootstrap from 'bootstrap/dist/js/bootstrap.min.js'
import { mapState, mapGetters } from 'vuex'
import PlayTCPAButton from './PlayTCPAButton.vue'
export default {
  components: { PlayTCPAButton },
  name: 'BulkSubmitOverlay',
  props: ['open'],
  emits: ['submitOffers', 'cancelOffer'],
  data () {
    return {
      disabledBulkSubmit: false,
      submitStep: 1,
      disabledCancel: false
    }
  },
  mounted () {
    this.initModal()
  },
  methods: {
    mapText (text) {
      const leadFields = [['__consumer_phone__', 'phone1'],
        ['__consumer_name__', 'fullname'],
        ['__consumer_email__', 'email'],
        ['__consumer_firstname__', 'firstname'],
        ['__consumer_lastname__', 'lastname'],
        ['__agent_id__', 'agent_id'],
        ['__agent_name__', 'agent_name'],
        ['__call_center_dba__', 'call_center_dba'],
        ['__consumer_address__', 'address'],
        ['__consumer_city__', 'city'],
        ['__consumer_state__', 'state'],
        ['__consumer_zip__', 'zip']]
      if (this.pendingBulkSubmits && this.pendingBulkSubmits.length > 0) {
        var loop_section = new RegExp('(?<=__list_external_offer_names__)(.*)(?=__/list_external_offer_names__)')

        if (text.match(loop_section) !== undefined) {
          var loop_text = ''
          this.offerNamesString.split(',').forEach((name, idx) => {
            if (text.match(loop_section) !== null) {
              loop_text += text.match(loop_section)[0].replace(new RegExp('__display_external_offer_name__', 'g'), '<label data-leadid_tcpa> <input type="checkbox" id="leadid_tcpa_brandname_' + idx + '" />' + name + '</label>' ?? '') + '<br/>'
            }
          })
          text = text.replace(new RegExp('__list_external_offer_names__.*__/list_external_offer_names__', 'g'), loop_text)
        }
        text = text.replace(new RegExp('__external_offer_names__', 'g'), this.offerNamesString)
      }
      if (this.leadInfo) {
        leadFields.forEach((item) => {
          text = text.replace(new RegExp(item[0], 'g'), this.leadInfo[item[1]] ?? '')
        })
      }
      return '<label><input type="hidden" id="leadid_tcpa_disclosure"/>' + text + '</label>'
    },
    campusNameFound (pending) {
      var campus = pending.offer.campuses.find(campus => campus.id === pending.leadRequest.raw_request.lead_education.campus_id)
      return campus === undefined ? undefined : campus.name
    },
    programNameFound (pending) {
      var program = pending.offer.programs.find(program => program.id === pending.leadRequest.raw_request.lead_education.program_id)
      return program === undefined ? undefined : program.name
    },
    async initModal () {
      await new Promise((resolve) => setTimeout(resolve, 100))
      this.modal = new bootstrap.Modal(document.getElementById('bulk-disclosure-overlay'), { backdrop: 'static', keyboard: false })
    },
    openModal () {
      this.modal.toggle()
      var backdrops = document.querySelectorAll('.modal-backdrop')
      backdrops.forEach((backdrop) => {
        backdrop.classList.add('bulk-submit')
      })
      this.disabledBulkSubmit = false
    },
    closeModal () {
      document.querySelectorAll('.modal-backdrop').forEach((backdrop) => {
        backdrop.classList.remove('bulk-submit')
      })
      this.modal.toggle()
    },
    submitStep1 () {
      if (this.multiConsentValid()) {
        this.submitStep = 2
      }
    },
    submitOffers () {
      if (!this.disabledBulkSubmit) {
        this.disabledBulkSubmit = true
        this.$emit('submitOffers')
      }
    },
    cancelOffer (pendingSubmit) {
      this.$emit('cancelOffer', pendingSubmit)
    },
    disableCancel (disabled) {
      this.disabledCancel = disabled
    },
    multiConsentValid () {
      let valid = true
      this.$el.querySelectorAll('label[data-leadid_tcpa] input').forEach((checkbox) => {
        if (!checkbox.checked) {
          checkbox.parentNode.classList.add('info-error')
          valid = false
        } else {
          checkbox.parentNode.classList.remove('info-error')
        }
      })
      return valid
    }
  },
  computed: {
    mappedBulkTcpa () {
      return this.mapText(this.bulkTcpa)
    },
    offerNamesString () {
      var output = ''
      var numPbs = this.pendingBulkSubmits.length
      for (var k = 0; k < numPbs; k++) {
        var nextName = this.pendingBulkSubmits[k].offer.name
        if (k === 0) {
          output = nextName
        } else if (k === numPbs - 1) {
          output += ',' + nextName
        } else {
          output += ',' + nextName
        }
      }
      return output
    },
    ...mapState({
      consumer: state => state.consumer.currentConsumer,
      bulkTcpa: state => state.consumer.bulkTcpa,
      pendingBulkSubmits: state => state.consumer.leadRequests.pendingBulkSubmits
    }),
    ...mapGetters({
      hasDisplayedType: 'consumer/hasDisplayedOverlayDisclosure',
      hasPlayTcpa: 'consumer/hasPlayTcpa',
      leadInfo: 'consumer/lead/leadInfo'
    })
  },
  watch: {
    open (val) {
      if (val) {
        this.submitStep = 1
        this.openModal()
      } else {
        this.closeModal()
      }
    }
  }
}
</script>

<style lang="scss">
.disclosure.modal-backdrop.show {
  background-color: black;
  opacity: 0.85;
}
.school-logo {
  max-width: 100%;
}
.school-title {
  padding-top: 5px;
  padding-bottom: 15px;
}
.bulk-tcpa-required {
  color: gray;
  font-size: 12px;
  padding-bottom: 5px;
}
.cancel-offer {
  float: right;
}
.info-error {
  color: red;
}
</style>
